const version = "2.11.4";

export { version };
//# sourceMappingURL=version.mjs.map
